import Spendbox from "../../assets/images/footlogo.svg";
import styled from "styled-components";

const Container = styled.div`
  background: #000000;
  text-align: center;
  align-items: end;
  display: flex;
  justify-content: space-between;
  text-decoration: underline;
  font-weight: 700;
  color: #ffffff;
  padding: 3.1em 10%;
  width: 100%;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
  p {
    cursor: pointer;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    padding: 2.5em 10%;
    display: block;
    width: 100%;
    justify-content: center;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
    p {
      margin-bottom: 3.1em;
      cursor: pointer;
    }
    p:last-child {
      margin-bottom: 0em;
    }
  }
`;

const ImageContainer = styled.div`
  width: 9.6em;
  height: 2em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin: 0 auto;
    margin-bottom: 3.1em;
  }
`;

const Footer = () => {
  return (
    <Container>
      <ImageContainer>
        <img src={Spendbox} alt="" />
      </ImageContainer>
      <p>
        <a
          href="https://jumpy-packet-b7e.notion.site/TERMS-OF-SERVICE-56dbabb9472d42a68bf91f204a1c3964/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and Conditions
        </a>
      </p>
      <p>
        <a
          href="https://wa.me/message/MDP76I5CDKCGG1"
          target="_blank"
          rel="noopener noreferrer"
        >
          {" "}
          Contact Us
        </a>
      </p>
    </Container>
  );
};

export default Footer;
